/**
 *  配电表计管理
 */
import * as HttpService from "../../../../service/HttpService";

/**
 * 查询模板列表
 */
export const queryTempList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/reportTmpl/getReportTmplCustomBySearch", params);
};

/**
 * 生成报表
 */
export const exportExcel = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/easypoi/excelSettlement",params);
};
